import type { OrganizationDetails, SiteConfiguration } from '../models';

/**
 * What steps 1 and 2 render while their APIs are still in flight.
 *
 * These exist so a slow or failed read degrades to an empty form rather than to a blocked page: every
 * field and dropdown stays on screen and stays editable. Blank strings rather than sample values, so
 * nothing here can be mistaken for real data or silently submitted.
 *
 * There is no `EMPTY_DROPDOWN_OPTIONS` and no `EMPTY_ADMINS` any more. The first served a single bulk
 * options payload that no endpoint provides -- each step now loads its own reference lists -- and the
 * second belonged to a client-held admins payload that the server is now the source of.
 */

export const EMPTY_ORGANIZATION_DETAILS: OrganizationDetails = {
  organizationId: '',
  organizationName: '',
  startDate: null,
  country: '',
  state: '',
  city: '',
  totalEmployee: '',
  gstNumber: '',
  panNumber: '',
  registrationNumber: '',
  userLicenseCount: '',
  domains: '',
  address: '',
  description: '',
  logoName: '',
  logoDataUrl: '',
  primaryContactName: '',
  primaryPhoneCode: '7',
  secondaryPhoneCode: '7',
  primaryPhone: '',
  secondaryPhone: '',
  organizationHead: '',
  personalEmail: '',
  workEmail: '',
};

export const EMPTY_SITE_CONFIGURATION: SiteConfiguration = {
  currency: '',
  dateFormat: '',
  timeFormat: '',
  timeZone: '',
  // The theme dialog needs a valid palette/mode pair to render at all.
  theme: { palette: 'default', mode: 'light' },
  loginImageName: '',
  loginImageDataUrl: '',
};
